import React from 'react';
import { Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { RawMaterialUse } from '../../../../../../../services/types/Calculator';
import NumberFormatterSinSeparador from '../../../NumberFormatterSinSeparador';

interface Props {
  rawMaterial: RawMaterialUse;
}

const RawMaterialsDetails: React.FC<Props> = ({ rawMaterial }) => {
  const { t } = useTranslation();

  return (
    <div className="table-wrapper">
      <Table
        responsive
        className="table--bordered calculator table-details"
        style={{ tableLayout: 'fixed' }}
      >
        <colgroup>
          <col style={{ width: '34%' }} />
          <col style={{ width: '20%' }} />
          <col style={{ width: '26%' }} />
          <col style={{ width: '20%' }} />
        </colgroup>
        <thead>
          <tr>
            <th>{t('Raw Material')}</th>
            <th>{t('Quantity Used (tons)')}</th>
            <th>{parse(t('Default CO<sub>2</sub> Emission Factor (kg C/tons)'))}</th>
            <th>{parse(t('CO<sub>2</sub> Emissions (tons)'))}</th>
          </tr>
        </thead>
        <tbody>
          {rawMaterial.rows.map((row) => (
            <tr key={row.id}>
              <td>{row.rawMaterial}</td>
              <td>
                <NumberFormatterSinSeparador value={row.quantity} />
              </td>
              <td>
                <NumberFormatterSinSeparador value={row.factor} />
              </td>
              <td>
                <NumberFormatterSinSeparador value={row.totalCarbon} />
              </td>
            </tr>
          ))}
          <tfoot>
            <tr>
              {/* espaciador intencional, sin contenido */}
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td colSpan={4} />
            </tr>
          </tfoot>
        </tbody>
      </Table>
    </div>
  );
};

export default RawMaterialsDetails;
